module.exports = __webpack_public_path__ + "static/media/btn_prev.b6874957.svg";